module.exports = __webpack_public_path__ + "img/nunito-sans-v11-latin-900.9409c596.svg";